import { Select, SelectProps } from '@mantine/core';

export type AdminSubawardeeFilterSelectProps = Omit<SelectProps, 'data'> & {
  value: string | null;
  onChange: (subawardee: string | null) => void;
  data: { value: string; label: string }[];
};

/**
 * Subawardee filter (friendly name → X-Selected-Group). Use inside a filters row with other Selects.
 */
export function AdminSubawardeeFilterSelect({
  value,
  onChange,
  disabled,
  style,
  styles: stylesProp,
  data,
  ...rest
}: AdminSubawardeeFilterSelectProps) {
  return (
    <Select
      label="Sub-awardee"
      clearable
      placeholder="All sub-awardees"
      searchable
      data={data}
      value={value}
      onChange={onChange}
      disabled={disabled}
      maxDropdownHeight={320}
      style={style}
      styles={stylesProp ?? {
        label: { marginBottom: '8px' },
        root: {
          '@media (max-width: 768px)': {
            width: '100%',
            minWidth: 'auto',
          },
        },
      }}
      {...rest}
    />
  );
}
